/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FeedbackQueryResult model module.
 * @module model/FeedbackQueryResult
 * @version 1.0
 */
class FeedbackQueryResult {
    /**
     * Constructs a new <code>FeedbackQueryResult</code>.
     * @alias module:model/FeedbackQueryResult
     */
    constructor() { 
        
        FeedbackQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FeedbackQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FeedbackQueryResult} obj Optional instance to populate.
     * @return {module:model/FeedbackQueryResult} The populated <code>FeedbackQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FeedbackQueryResult();

            if (data.hasOwnProperty('applicant')) {
                obj['applicant'] = ApiClient.convertToType(data['applicant'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} applicant
 */
FeedbackQueryResult.prototype['applicant'] = undefined;

/**
 * @member {String} createdAt
 */
FeedbackQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} deletedAt
 */
FeedbackQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
FeedbackQueryResult.prototype['id'] = undefined;

/**
 * @member {String} message
 */
FeedbackQueryResult.prototype['message'] = undefined;

/**
 * @member {String} updatedAt
 */
FeedbackQueryResult.prototype['updatedAt'] = undefined;

/**
 * @member {Number} userId
 */
FeedbackQueryResult.prototype['userId'] = undefined;






export default FeedbackQueryResult;

